import React from 'react';

import { Container, Grid, Speaker } from './styles';
import {urlWebsite} from '../../config';


interface ISpeakerData {
  name: string;
  photo: string;
  position?: string;
  description?: string;
}

interface IGrid {
  id?: string;
  speakers?: Array<ISpeakerData>;
}

interface ISpeaker {
  background: string;
}

const SpeakerGrid: React.FC<IGrid> = ({
  speakers = [],
  id = 'palestrantes',
}) => {
  return (
    <Container id={id}>
      <div className="title">
        <h2>Palestrantes</h2>
      </div>

      <Grid>
        {speakers.map(speaker => {
          return (
            <Speaker background={`${urlWebsite}/${speaker.photo}`}>
              <div>
                <h2>{speaker.name}</h2>
                <p dangerouslySetInnerHTML={ {__html : speaker.description || ''} }/>
              </div>
            </Speaker>
          );
        })}
      </Grid>
    </Container>
  );
};

export default SpeakerGrid;
